/* Shared carousel behavior: dot navigation, desktop drag-to-scroll, optional infinite loop.
   Loop mode clones the card set on both sides and re-centers the scroll position when
   the viewport drifts into a clone set, so every dot works and dragging never hits an edge. */
window.MCarousel = function (trackId, dotsId, opts) {
  opts = opts || {};
  var track = document.getElementById(trackId);
  if (!track || track.dataset.mcInit) return;
  track.dataset.mcInit = '1';
  var orig = [].slice.call(track.children);
  var N = orig.length;
  var loop = !!opts.loop && N > 1;
  var setW = 0;

  if (loop) {
    var pre = document.createDocumentFragment(), post = document.createDocumentFragment();
    orig.forEach(function (c) {
      var a = c.cloneNode(true); a.setAttribute('aria-hidden', 'true'); pre.appendChild(a);
      var b = c.cloneNode(true); b.setAttribute('aria-hidden', 'true'); post.appendChild(b);
    });
    track.insertBefore(pre, track.firstChild);
    track.appendChild(post);
  }
  var all = [].slice.call(track.children);
  if (loop) {
    setW = all[N].offsetLeft - all[0].offsetLeft; /* exact period incl. gaps */
    track.scrollLeft = setW;
  }

  function normalize() {
    if (!loop) return;
    if (setW <= 0) { setW = all[N].offsetLeft - all[0].offsetLeft; if (setW <= 0) return; }
    if (track.scrollLeft < setW * 0.5) track.scrollLeft += setW;
    else if (track.scrollLeft >= setW * 1.5) track.scrollLeft -= setW;
  }

  /* manual eased scroll: Chrome cancels smooth scrollTo on mandatory-snap tracks */
  var anim = null;
  function stopAnim() { if (anim) { clearInterval(anim); anim = null; track.style.scrollSnapType = ''; } }
  function animateTo(target) {
    stopAnim();
    var start = track.scrollLeft, dist = target - start;
    if (!dist) return;
    var t0 = performance.now(), dur = Math.min(650, 250 + Math.abs(dist) * 0.25);
    track.style.scrollSnapType = 'none';
    anim = setInterval(function () {
      var p = Math.min(1, (performance.now() - t0) / dur);
      track.scrollLeft = start + dist * (1 - Math.pow(1 - p, 3));
      if (p >= 1) { clearInterval(anim); anim = null; setTimeout(function () { track.style.scrollSnapType = ''; }, 60); }
    }, 16);
  }
  track.addEventListener('wheel', stopAnim, { passive: true });

  function logicalIdx() {
    var x = track.scrollLeft, idx = 0, best = 1e9;
    all.forEach(function (card, i) {
      var d = Math.abs((card.offsetLeft - track.offsetLeft) - x);
      if (d < best) { best = d; idx = i; }
    });
    return loop ? idx % N : idx;
  }

  function setActive(i) { dots.forEach(function (d, k) { if (k === i) { d.setAttribute('aria-current', 'true'); } else { d.removeAttribute('aria-current'); } }); }
  /* dots (optional) */
  var dots = [];
  var dotsBox = dotsId ? document.getElementById(dotsId) : null;
  if (dotsBox) {
    orig.forEach(function (card, i) {
      var b = document.createElement('button');
      b.type = 'button';
      if (i === 0) b.setAttribute('aria-current', 'true');
      b.addEventListener('click', function () {
        normalize();
        animateTo(card.offsetLeft - track.offsetLeft);
        setActive(i);
      });
      dotsBox.appendChild(b);
    });
    dots = [].slice.call(dotsBox.children);
  }

  var t, lastLive = 0;
  track.addEventListener('scroll', function () {
    /* live highlight while scrolling (throttled); normalize only after settle */
    var now = Date.now();
    if (now - lastLive > 66) { lastLive = now; setActive(logicalIdx()); }
    clearTimeout(t);
    t = setTimeout(function () {
      normalize();
      setActive(logicalIdx());
    }, 120);
  }, { passive: true });

  /* drag-to-scroll (mouse only; touch already scrolls natively) */
  var down = false, moved = false, startX = 0, startLeft = 0;
  track.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse' || e.button !== 0) return;
    stopAnim();
    down = true; moved = false; startX = e.clientX; startLeft = track.scrollLeft;
    track.style.scrollSnapType = 'none';
    track.classList.add('m-dragging');
  });
  track.addEventListener('pointermove', function (e) {
    if (!down) return;
    var dx = e.clientX - startX;
    if (Math.abs(dx) > 5 && !moved) { moved = true; try { track.setPointerCapture(e.pointerId); } catch (err) {} }
    if (moved) { track.scrollLeft = startLeft - dx; e.preventDefault(); }
  });
  function release() {
    if (!down) return;
    down = false;
    track.classList.remove('m-dragging');
    normalize();
    var x = track.scrollLeft, target = all[0], best = 1e9;
    all.forEach(function (card) {
      var d = Math.abs((card.offsetLeft - track.offsetLeft) - x);
      if (d < best) { best = d; target = card; }
    });
    animateTo(target.offsetLeft - track.offsetLeft);
    setActive(loop ? all.indexOf(target) % N : all.indexOf(target));
    setTimeout(function () { if (!anim) track.style.scrollSnapType = ''; }, 500);
  }
  track.addEventListener('pointerup', function () { release(); setTimeout(function () { moved = false; }, 0); });
  track.addEventListener('pointercancel', release);
  track.addEventListener('mouseleave', release);
  /* swallow the click that ends a drag so links/buttons inside don't fire */
  track.addEventListener('click', function (e) {
    if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
  }, true);
};
